import React, { useState, useRef, useEffect } from 'react';
import RAvatarEditor from 'react-avatar-editor';
import { Button, Slider } from 'antd';
import message from '@web-common/components/UI/Message/SiriusMessage';
import { apiHolder, apis } from 'api';
import styles from './avatarEditor.module.scss';
import Toast from '../Message/SiriusMessage';
import { useAppDispatch } from '@web-common/state/createStore';
import { useContactModel } from '@web-common/hooks/useContactModel';
import { getIn18Text } from 'api';
import { doUpdateLxContactMap } from '@web-common/state/reducer/contactReducer';
import lodashGet from 'lodash/get';
import cloneDeep from 'lodash/cloneDeep';
import { getCharAvatar } from '@web-contact/util';
const nimApi = apiHolder.api.requireLogicalApi('NIM');
const systemApi = apiHolder.api.getSystemApi();
const storeApi = apiHolder.api.getDataStoreApi();
const contactApi = apiHolder.api.requireLogicalApi(apis.contactApiImpl);
const AvatarEditor = ({ avatar, hideAvatarEditor, contactId, contactEmail, teamId, showResetEntry = false, onConfirm, onImageError, useLocalImg = false, }) => {
    var _a;
    const dispatch = useAppDispatch();
    const contactModel = useContactModel({ email: contactEmail, contactId });
    const [scale, setScale] = useState(1);
    const [sliderValue, setSliderValue] = useState(0);
    const [curImage, setCurImage] = useState(avatar);
    const [loading, setLoading] = useState(false);
    const avatarEditorRef = useRef(null);
    const picInputRef = useRef(null);
    const [defaultAvatarStyle] = useState({ background: contactApi.getColor(contactEmail || lodashGet(systemApi.getCurrentUser(), 'id', '')) });
    const [defaultName] = useState(getCharAvatar(((_a = contactModel === null || contactModel === void 0 ? void 0 : contactModel.contact) === null || _a === void 0 ? void 0 : _a.contactName) || lodashGet(systemApi.getCurrentUser(), 'nickName', '')));
    const changePic = () => {
        var _a;
        (_a = picInputRef.current) === null || _a === void 0 ? void 0 : _a.click();
    };
    const deletePic = async () => {
        setCurImage('');
    };
    const setCurrentUserAvatar = (newUrl) => {
        const user = systemApi.getCurrentUser();
        if (user) {
            user.avatar = newUrl;
            storeApi.setLastAccount(user);
        }
    };
    const confirmDeletePic = async () => {
        var _a, _b, _c, _d;
        try {
            const res = await contactApi.deleteAvatarIcon();
            if (!((_a = res.data) === null || _a === void 0 ? void 0 : _a.success)) {
                Toast.error({ content: res.message || '重置头像失败' });
                setLoading(false);
                return;
            }
            const selfId = ((_d = (_c = (_b = systemApi.getCurrentUser()) === null || _b === void 0 ? void 0 : _b.contact) === null || _c === void 0 ? void 0 : _c.contact) === null || _d === void 0 ? void 0 : _d.id) || '';
            if (selfId) {
                await contactApi.doUpdateContactById({ id: selfId, avatar: '' });
            }
            setCurrentUserAvatar('');
            setLoading(false);
            hideAvatarEditor();
        }
        catch (ex) {
            Toast.error({ content: '重置头像失败' });
        }
    };
    const picInputChange = () => {
        var _a;
        const files = (_a = picInputRef === null || picInputRef === void 0 ? void 0 : picInputRef.current) === null || _a === void 0 ? void 0 : _a.files;
        if (files && files[0]) {
            const maxSize = 15 * 1024 * 1024;
            if (files[0].size > maxSize) {
                message.warn({
                    content: getIn18Text('TUPIANDAXIAOBU'),
                });
                return;
            }
            setCurImage(files[0]);
        }
    };
    const cancel = () => {
        hideAvatarEditor();
    };
    const confirm = () => {
        var _a;
        if (curImage === '') {
            return confirmDeletePic();
        }
        const editotCanvas = (_a = avatarEditorRef === null || avatarEditorRef === void 0 ? void 0 : avatarEditorRef.current) === null || _a === void 0 ? void 0 : _a.getImageScaledToCanvas();
        const mimeType = 'image/png';
        setLoading(true);
        editotCanvas.toBlob(async (blob) => {
            if (!blob) {
                setLoading(false);
                return;
            }
            const fileName = getIn18Text('TOUXIANG.pn');
            if (onConfirm) {
                onConfirm(new File([blob], fileName));
                setLoading(false);
                return;
            }
            if (!contactId && !teamId && !contactEmail) {
                console.log('缺乏用户或群组参数');
                setLoading(false);
                return;
            }
            if (teamId) {
                const file = await nimApi.excute('previewFile', {
                    type: 'image',
                    blob,
                });
                nimApi.excute('updateTeam', {
                    teamId,
                    avatar: file.url,
                });
                setLoading(false);
                hideAvatarEditor();
                return;
            }
            if (contactId || contactEmail) {
                const hPic = new File([blob], fileName, { type: mimeType });
                contactApi
                    .uploadIcon({ file: hPic, fileName })
                    .then(async (res) => {
                    var _a, _b;
                    if (!res.success || !res.data) {
                        Toast.error({ content: res.message || getIn18Text('SHANGCHUANTOUXIANGSHI') });
                        setLoading(false);
                        return;
                    }
                    const newUrl = res.data.mediumUrl;
                    try {
                        let _contactId = contactId;
                        if (!contactId) {
                            const contactRes = await contactApi.doGetContactByEmailFilter({ emails: [contactEmail] });
                            if (contactRes) {
                                _contactId = (_b = (_a = contactRes[contactEmail]) === null || _a === void 0 ? void 0 : _a.contact) === null || _b === void 0 ? void 0 : _b.id;
                            }
                        }
                        setCurrentUserAvatar(newUrl);
                        if (contactId) {
                            const modDBRes = await contactApi.doUpdateContactById({ id: _contactId, avatar: newUrl });
                            setLoading(false);
                            if (!modDBRes) {
                                console.log('数据库同步失败');
                                if (contactModel) {
                                    const contactModelCopied = cloneDeep(contactModel);
                                    contactModelCopied.contact.avatar = newUrl;
                                    doUpdateLxContactMap([contactModel]);
                                    hideAvatarEditor();
                                }
                                else {
                                    Toast.error({ content: '数据库同步失败' });
                                }
                                return;
                            }
                        }
                        hideAvatarEditor();
                    }
                    catch (err) {
                        console.log(getIn18Text('SHANGCHUANTOUXIANGSHI'), err);
                        Toast.error({ content: getIn18Text('SHANGCHUANTOUXIANGSHI') });
                        setLoading(false);
                    }
                })
                    .catch(err => {
                    console.log(getIn18Text('SHANGCHUANTOUXIANGSHI'), err);
                    Toast.error({ content: getIn18Text('SHANGCHUANTOUXIANGSHI') });
                    setLoading(false);
                });
            }
        }, mimeType);
    };
    const onSliderChange = (value) => {
        setSliderValue(value);
        setScale(1 + value / 100);
    };
    const changeSliderValue = (action) => {
        let val = sliderValue;
        if (action === 'add' && val < 100) {
            val += 10;
        }
        if (action === 'sub' && val > 0) {
            val -= 10;
        }
        setScale(1 + val / 100);
        setSliderValue(val);
    };
    const useLocalImgFn = () => {
        const wenToolbarAvatarTag = document.querySelector('.webToolbarAvatarTagWrapper');
        const textAvatar = wenToolbarAvatarTag === null || wenToolbarAvatarTag === void 0 ? void 0 : wenToolbarAvatarTag.querySelector('.avatarTag');
        const imgAvatar = textAvatar === null || textAvatar === void 0 ? void 0 : textAvatar.querySelector('img');
        const canvas = document.createElement('canvas');
        canvas.width = 476;
        canvas.height = 476;
        const ctx = canvas.getContext('2d');
        if (!ctx)
            return;
        console.log('avatardd', imgAvatar === null || imgAvatar === void 0 ? void 0 : imgAvatar.src);
        if (imgAvatar && imgAvatar.src) {
            const im = new Image();
            im.crossOrigin = 'Anonymous';
            im.onload = function () {
                console.log('avatardd1');
                ctx.drawImage(im, 0, 0);
                canvas.toBlob(blob => {
                    console.log('avatardd12');
                    const filepng = new File([blob], 'avatar.png', { type: 'image/png' });
                    setCurImage(filepng);
                }, 'image/png', 1);
            };
            im.src = imgAvatar.src.replace('80x80', '480x480');
        }
        else if (textAvatar) {
            const text = textAvatar.innerText;
            const bgColor = textAvatar.style.backgroundColor || '';
            console.log('avatardd1', text, bgColor);
            ctx.fillStyle = bgColor;
            ctx.fillRect(0, 0, 476, 476);
            ctx.font = '175px Arial';
            ctx.fillStyle = '#fff';
            ctx.textAlign = 'center';
            ctx.textBaseline = 'middle';
            ctx.fillText(text, canvas.width / 2, canvas.height / 2);
            canvas.toBlob(blob => {
                console.log('avatardd12');
                const filepng = new File([blob], 'avatar.png', { type: 'image/png' });
                setCurImage(filepng);
            }, 'image/png', 1);
        }
    };
    useEffect(() => {
        setCurImage(avatar);
    }, [avatar]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: styles.bg, onClick: cancel }),
        React.createElement("div", { className: styles.avatarEditorPopUp },
            typeof curImage === 'string' && curImage.length == 0 ? (React.createElement("div", { className: styles.defaultAvatarBg, style: defaultAvatarStyle }, defaultName)) : (React.createElement(RAvatarEditor, { ref: avatarEditorRef, crossOrigin: "anonymous", image: curImage, width: 476, height: 476, border: 0, borderRadius: 500, color: [0, 0, 0, 0.7], scale: scale, rotate: 0, onLoadFailure: onImageError })),
            typeof curImage === 'string' && curImage.length == 0 ? null : (React.createElement("div", { className: styles.slider },
                React.createElement("div", { className: styles.sliderAction, onClick: () => {
                        changeSliderValue('sub');
                    } }),
                React.createElement("div", { className: styles.sliderArea },
                    React.createElement(Slider, { defaultValue: 0, value: sliderValue, tooltipVisible: false, onChange: onSliderChange })),
                React.createElement("div", { className: styles.sliderAction, onClick: () => {
                        changeSliderValue('add');
                    } }))),
            React.createElement("div", { className: styles.bottom },
                React.createElement("div", { className: styles.leftArea },
                    React.createElement(Button, { type: "link", className: styles.changePic, onClick: changePic, disabled: loading }, getIn18Text('GENGHUANTUPIAN')),
                    showResetEntry ? (React.createElement(Button, { type: "link", className: styles.deletePic, onClick: deletePic, disabled: loading }, "\u5220\u9664\u56FE\u7247\u6062\u590D\u9ED8\u8BA4")) : null,
                    useLocalImg && (React.createElement(Button, { type: "link", className: styles.deletePic, onClick: useLocalImgFn, disabled: loading }, "\u4F7F\u7528\u672C\u5730\u5934\u50CF"))),
                React.createElement("div", { className: styles.rightArea },
                    React.createElement(Button, { className: styles.cancel, onClick: cancel }, getIn18Text('QUXIAO')),
                    React.createElement(Button, { type: "primary", className: styles.confirm, onClick: confirm, loading: loading, disabled: loading }, getIn18Text('QUEDING'))),
                React.createElement("input", { ref: picInputRef, type: "file", accept: "image/gif, image/jpeg, image/jpg, image/png", className: styles.picInput, onClick: e => {
                        const input = e.target;
                        input.value = '';
                    }, onChange: picInputChange })))));
};
export default AvatarEditor;
